module.exports = __webpack_public_path__ + "static/media/generic-02.13a67d1b.svg";